import { isMobileApp } from '@airtel-lego/native-app-bridge';
import { Button, Header, Typography } from '@airtel/air-design-system';
import { isUserLoggedIn } from '@airtel/air-utils';
import { useLayoutEffect } from 'react';
import './NotFound.scss';

const NotFoundPage = () => {
   const removeDummyContentLoader = () => {
      try {
         const initLoader: any = document.querySelector('#init-loader');
         document.body.removeChild(initLoader);
      } catch (error) {
         //
      }
   };

   useLayoutEffect(() => {
      removeDummyContentLoader();
   }, []);

   return (
      <>
         <Header isUserLoggedIn={isMobileApp() || isUserLoggedIn()} />
         <div className="not-found-container">
            <img
               src="https://assets.airtel.in/static-assets/selfcare/images/404/group-158@2x.png"
               width={360}
               height={198}
               alt="404"
            />
            <Typography
               style={{
                  marginVertical: 16,
               }}
               type="body-para-xl"
               text="Page you are looking for could not be found."
               color="#666666"
            />
            <Button
               buttonType="tertiary"
               title="Go Home"
               onPress={() => {
                  window.location.href = '/kyc';
               }}
            />
         </div>
      </>
   );
};

export default NotFoundPage;
